import {graphql} from 'react-relay';
import * as tracking from '../tracking';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation CreateProfileMutation($input: CreateProfileInput!) {
		createProfile(input: $input) {
			profile {
				node {
					id
					name
					canBeEdited
					personsCount
					permissions
				}
			}
		}
	}
`;

function getConfigs(companyId) {
	const configs = [
		{
			type: 'RANGE_ADD',
			parentID: companyId,
			connectionInfo: [
				{
					key: 'Company_profiles',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'profile',
		},
	];

	return configs;
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Profile Created');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), name: input.name}},
		configs: getConfigs(input.companyId),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
